/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Only provided for WebhookType==VehicleReport
 * @export
 * @interface VehicleReportMetadata
 */
export interface VehicleReportMetadata {
    /**
     * Report period
     * @type {string}
     * @memberof VehicleReportMetadata
     */
    period?: VehicleReportMetadataPeriodEnum;
}

/**
 * @export
 */
export const VehicleReportMetadataPeriodEnum = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Annually: "Annually",
} as const;
export type VehicleReportMetadataPeriodEnum =
    (typeof VehicleReportMetadataPeriodEnum)[keyof typeof VehicleReportMetadataPeriodEnum];

/**
 * Check if a given object implements the VehicleReportMetadata interface.
 */
export function instanceOfVehicleReportMetadata(
    value: object,
): value is VehicleReportMetadata {
    return true;
}

export function VehicleReportMetadataFromJSON(
    json: any,
): VehicleReportMetadata {
    return VehicleReportMetadataFromJSONTyped(json, false);
}

export function VehicleReportMetadataFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): VehicleReportMetadata {
    if (json == null) {
        return json;
    }
    return {
        period: json["period"] == null ? undefined : json["period"],
    };
}

export function VehicleReportMetadataToJSON(
    value?: VehicleReportMetadata | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        period: value["period"],
    };
}
